import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import GF from "../../../../../lib/utils/GF";
import InputSearchDropDown from "../../inputFields/dropdown/InputSearchDropDown";
import Operator from "../../../../../lib/model/query/Operator";

class OperatorSelection extends BaseComponent {

  componentDidMount() {
    super.componentDidMount();
    this.onOperatorValueChange(null);
  }

  onOperatorValueChange(e, id, value) {
    if (GF.checkNotNull(this.props.fieldPredicateRef) && GF.checkNotNull(this.props.fieldPredicateRef.current)) {
      this.props.fieldPredicateRef.current.onOperatorValueChange(e, id, value);
    }
  }

  onChange(e, id, option) {
    this.onOperatorValueChange(e, id, option.id);
    if (GF.checkNotNull(this.props.onChange)) {
      this.props.onChange(e, id, option.id);
    }
  }

  mapOperatorToDefault(operator) {
    if (operator === '==') {
      operator = '=';
    }
    return operator;
  }

  render() {
    let currentOperator = Operator.extendWithLabel(
      this.mapOperatorToDefault(GF.getValue(this.props.currentOperator, '=')));
    let operatorListFromProps = (this.props.operatorList !== undefined ? this.props.operatorList : []);
    if (operatorListFromProps.length === 0) {
      operatorListFromProps = [[Operator.eq, Operator.get().eq_label], [Operator.neq, Operator.get().neq_label],
        [Operator.lt, Operator.get().lt_label], [Operator.gt, Operator.get().gt_label],
        [Operator.leq, Operator.get().leq_label], [Operator.geq, Operator.get().geq_label],
        [Operator.like, Operator.get().like_label], [Operator.null, Operator.get().null_label],
        [Operator.not_null, Operator.get().not_null_label]];
    }

    let operatorList = operatorListFromProps.map(([id, label]) => ({id, label}));

    return <InputSearchDropDown
      size={'small'}
      labelElement={'Operator'}
      onChange={(e, id, value) => this.onChange(e, id, value)}
      defaultValue={{
        id: GF.getValue(currentOperator[0]), label: GF.getValue(currentOperator[1])
      }}
      disableClearable={true}>
      {operatorList}
    </InputSearchDropDown>;
  }
}

OperatorSelection.propTypes = {
  operatorList: PropTypes.arrayOf(PropTypes.object),
  fieldPredicateRef: PropTypes.object,
  currentOperator: PropTypes.string,
  onChange: PropTypes.func
}
export default OperatorSelection;
